import React, { Fragment } from "react";
import PropTypes from "prop-types";
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { get, postWithHeaders, patch } from '../../../server/actions';
import { _addNotification, allowNumericWithdecimal, _addNotificationError, gradeTextToNumber, getSchoolGrades, groupBy } from '../../../server/util'
import moment from 'moment';
import { text2num } from '../../../server/word2number';
var converter = require('number-to-words');

class EventRecord extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            event: {},
            id: 0,
            selectedOption: []
        }
        this.bindEvent = this.bindEvent.bind(this);
    }
    componentWillMount = () => {
        let eid = this.context.router.route.match.params.eid;
        this.setState({ id: eid }, () => {
            this.bindEvent()
        })
        // this.bindEvent();
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    bindEvent = () => {
        if (this.state.id <= 0) {
            return false;
        }
        get('/eventInfoes/' + this.state.id + '?&access_token=')
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then((data) => {
                let _event = data;
                _event.startDate = moment(new Date(data.startDate)).format('YYYY-MM-DD')
                _event.endDate = moment(new Date(data.endDate)).format('YYYY-MM-DD');
                this.setState({ event: _event || {} })
            }).catch((error) => {
                this.setState({ event: {} })
            })
    }
    getGrades = (grades) => {
        let allGrades = getSchoolGrades(0, false);
        var gradesGroup = groupBy(allGrades, 'value');
        let gradeList = [];
        (grades || []).forEach(grade => {
            const g = (gradesGroup[grade] || [])[0];
            if (g) {
                gradeList.push(g);
            }

            /* if(typeof grade ==='number'){
                gradeList.push({ value: converter.toWords(grade) , label: grade });
            }else{
                
                gradeList.push({ value: grade , label: gradeTextToNumber(grade) });
            }   */
        });
        return gradeList;
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div class="input-group">
                <input {...props} />
                <div class="input-group-btn">
                    <button type="button" className="btn btn-success" style={{ margin: '0px' }} onClick={openCalendar}>
                        <i className="fa fa-calendar"> </i>
                    </button>
                </div>
            </div>
        );
    }
    validateData = () => {
        if ((this.state.event.eventName || '').trim() == '') {
            _addNotificationError("Please Enter Event Name", this)
            return false
        }
        if ((this.state.event.configurableMsg || '').trim() == '') {
            _addNotificationError("Please enter notification message.", this)
            return false

        }
        if (!this.state.event.startDate) {
            _addNotificationError("Please select Start Date", this)
            return false
        }
        if (!this.state.event.endDate) {
            _addNotificationError("Please select End Date", this)
            return false
        }
        if ((this.state.event.type || '').trim() == '') {
            _addNotificationError("Please select Event type", this)
            return false
        }
        if ((this.state.event.grades || []).length <= 0) {
            _addNotificationError("Please select grades", this)
            return false
        }
        if ((this.state.event.type || '').trim() !== 'Donation') {
            if ((this.state.event.amount || '') == '') {
                _addNotificationError("Please enter amount", this)
                return false
            }
        }
        return true
    }
    handleChange = selectedOption => {
        let _event = this.state.event;
        _event.grades = [];
        (selectedOption || []).forEach(item => {
            _event.grades.push(item.value)
        })
        this.setState({ event: _event })
    };
    onChange = (e) => {
        let _event = this.state.event;
        _event[e.target.name] = e.target.value;
        this.setState({ event: _event })
    }
    onSubmit = (e) => {
        if (!this.validateData()) {
            return false;
        }
        this.setState({ loading: true });
        let headers = {
            'Content-Type': 'application/json'
        };
        let _event = { ...this.state.event };
        _event.mealSchool = '/mealManage/schools/' + sessionStorage.getItem('SchoolId');
        _event.schoolYear = sessionStorage.getItem('schoolYearValue');
        if (this.state.id > 0) {
            patch('/eventInfoes/' + this.state.id + '?access_token=', JSON.stringify(_event)).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                _addNotification("Event save successfully.", this);
                this.setState({ loading: false },
                    () => {
                        setTimeout(() => {
                            this.context.router.history.push('/schoolAdmin/events')
                        }, 1000)
                    });
            }).catch(
                (error) => {
                    console.log('Event data not saved', error);
                    this.setState({ loading: false });
                }
            );

        } else {
            postWithHeaders('/eventInfoes?access_token=', JSON.stringify(_event), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                _addNotification("Event save successfully.", this);
                this.setState({ loading: false },
                    () => {
                        setTimeout(() => {
                            this.context.router.history.push('/schoolAdmin/events')
                        }, 1000)
                    });
            }).catch(
                (error) => {
                    console.log('Event data not saved', error);
                    this.setState({ loading: false });
                }
            );
        }

    }
    render() {
        const { event } = this.state;
        const options = getSchoolGrades(0, false);//this.getGrades(this.props.grades);            
        return (<Fragment>
            <section className=" full-width clearfix margin-top">
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                    <NotificationSystem ref="notificationSystem" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 col-sm-12 col-xs-12 col-centered createmenu-panel">
                            <div className="panel panel-primary">
                                <div className="panel-heading">
                                    <h3 className="panel-title"><span>{this.state.id <= 0 ? "Add New Event" : "Edit Event"}</span></h3>
                                </div>
                                <div className="panel-body">
                                    <form className="form-horizontal">
                                        <div className="form-group">
                                            <label for="eventName" className="col-sm-4 control-label">Event Name*:</label>
                                            <div className="col-sm-8">
                                                <input type="text" name="eventName" id="eventName"
                                                    className="form-control" value={event.eventName}
                                                    placeholder="" onChange={this.onChange} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label for="configurableMsg" className="col-sm-4 control-label">Notification Message*:</label>
                                            <div className="col-sm-8">
                                                <input type="text" name="configurableMsg" id="configurableMsg"
                                                    className="form-control" value={event.configurableMsg}
                                                    placeholder="" onChange={this.onChange} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label for="startDate" className="col-sm-4 control-label">Start Date*:</label>
                                            <div className="col-sm-8">

                                                <Datetime ref='calendar' name="startDate" id="startDate"
                                                    dateFormat="MM/DD/YYYY"
                                                    timeFormat={false}
                                                    closeOnSelect={true}
                                                    value={moment(event.startDate, 'YYYY-MM-DD')}
                                                    onChange={(e) => {
                                                        let _event = this.state.event;
                                                        _event.startDate = (e || '') === '' ? undefined : moment(e).format('YYYY-MM-DD');
                                                        this.setState({ event: _event })
                                                    }} renderInput={this.renderInput} />

                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label for="endDate" className="col-sm-4 control-label">End Date*:</label>
                                            <div className="col-sm-8">

                                                <Datetime ref='calendar' name="endDate" id="endDate"
                                                    dateFormat="MM/DD/YYYY"
                                                    timeFormat={false}
                                                    closeOnSelect={true}
                                                    value={moment(event.endDate, 'YYYY-MM-DD')}
                                                    onChange={(e) => {
                                                        let _event = this.state.event;
                                                        _event.endDate = (e || '') === '' ? undefined : moment(e).format('YYYY-MM-DD');
                                                        this.setState({ event: _event })
                                                    }} renderInput={this.renderInput} />

                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label for="type" className="col-sm-4 control-label">Event Type*:</label>
                                            <div className="col-sm-8">
                                                <select className="form-control" id="type"
                                                    name="type" value={event.type} onChange={this.onChange} >
                                                    <option value=""></option>
                                                    <option value="Priced">Priced</option>
                                                    <option value="Donation">Donation</option>
                                                </select>
                                            </div>
                                        </div>
                                        {
                                            event.type !== 'Donation' ?
                                                <div className="form-group">
                                                    <label for="amount" className="col-sm-4 control-label">Price*:</label>
                                                    <div className="col-sm-8">
                                                        <input type="text" id="amount" name="amount"
                                                            className="form-control" value={event.amount}
                                                            onKeyUp={(e) => { allowNumericWithdecimal(e) }}
                                                            onChange={this.onChange} />
                                                    </div>
                                                </div>
                                                : null
                                        }
                                        <div className="form-group">
                                            <label for="grades" className="col-sm-4 control-label">Grades*:</label>
                                            <div className="col-sm-8">
                                                <Select isMulti={true} closeMenuOnSelect={false} name="grades" id="grades"
                                                    value={this.getGrades(event.grades)}
                                                    onChange={this.handleChange}
                                                    options={options} />

                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label for="longDesc" className="col-sm-4 control-label">Description:</label>
                                            <div className="col-sm-8">
                                                <textarea className="form-control" name="longDesc" id="longDesc"
                                                    value={event.longDesc} onChange={this.onChange}></textarea>
                                            </div>

                                        </div>
                                        <div className="form-group">
                                            <div className="col-sm-12 text-right">
                                                <button type="button" className="btn btn-success"
                                                    onClick={this.onSubmit}>Save</button>
                                                <button type="button" className="btn btn-danger" onClick={(e) => {
                                                    this.context.router.history.push('/schoolAdmin/events')
                                                }}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>)
    }
}
EventRecord.contextTypes = {
    router: PropTypes.object.isRequired
}
export default EventRecord


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManageEvents/EventRecord.jsx